/*
 * Copyright (c) 2014-2023 Inovalon, Inc. All Rights Reserved.
 * This computer program is CONFIDENTIAL and a TRADE SECRET of Inovalon, Inc.
 * The receipt or possession of this program does not convey any rights to use, reproduce or disclose
 * its contents in whole or in part, without the specific written consent of Inovalon, Inc.
 * Any use, reproduction or disclosure of this program without the express written consent of Inovalon, Inc.
 * is a violation of the copyright laws and may subject you to criminal prosecution.
 */
import axios from 'axios'
import { injectable } from 'inversify'
import { IViewReportApiClient } from './contracts'
import { SettingsManager } from '../../configuration/SettingsManager'
import { injectProperty } from '../../arc/configuration/ServiceLocator'
import { IUserSessionMiddleware } from '../../arc/middleware/UserSessionMiddleware/contracts'
import { ErrorHelper } from '../../utils/ErrorHelper'
import { ICoverageDiscoveryViewReportGridResults } from '../RequestHistoryStateManager/contracts'

@injectable()
export class ViewReportApiClient implements IViewReportApiClient {
	@injectProperty('IUserSessionMiddleware')
	private readonly userSessionMiddleware!: IUserSessionMiddleware

	getReportDetailsOnCompletion(): Promise<ICoverageDiscoveryViewReportGridResults> {
		const dateTimeStamp = `t=${Date.now()}`
		const url = `${SettingsManager.REACT_APP_MAIN_API_BASE_URL().value}/transactionexportrequests/generatedReports?${dateTimeStamp}`
		return this.userSessionMiddleware
			.loadSessionJwt()
			.then(token =>
				axios.get(url, {
					headers: {
						Authorization: `Bearer ${token}`,
					},
				}),
			)
			.then(response => response.data)

			.catch(error => {
				ErrorHelper.handleApiError(error)
			})
	}

	deleteSelectedReport(id: number): Promise<void> {
		const dateTimeStamp = `t=${Date.now()}`
		const url = `${SettingsManager.REACT_APP_MAIN_API_BASE_URL().value}/transactionexportrequests/${id}?${dateTimeStamp}`
		return this.userSessionMiddleware
			.loadSessionJwt()
			.then(token =>
				axios.delete(url, {
					headers: {
						Authorization: `Bearer ${token}`,
					},
				}),
			)
			.then(response => response.data)

			.catch(error => {
				ErrorHelper.handleApiError(error)
			})
	}
}
